

























import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { LessonsService } from '../../biz/remote/LessonsService';
import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import { dayjs, DTW_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { LessonStates } from '../../../src_server/entity/master/LessonStates';
import { reportSend } from '../../biz/reportSendLogic';
import { MessageDialog } from '../../utils/MessageDialog';
import { DaLessonsService } from '../../biz/remote/DaLessonsService';
import { Session } from 'src_client/utils/Session';

@Component({
  components: { CommonDialog },
  filters: {
    dateFormat: (date: Date) => {
      return dayjs(date).format(DTW_FORMAT_JA);
    },
    stateFormat: (state: string) => {
      return LessonStates.getDaState(state);
    },
  },
})
export default class DaLessonDialog extends Vue {
  private title = '';
  private lessons: LessonDTO[] = [];

  private getStateCSS(state: string) {
    return LessonStates.getBadgeClassByState(state);
  }
  private async report(class_id: number) {
    reportSend(this, class_id, 'report');
    // routeHelper(this, 'DaAdminDailyReportPage', { class_id: class_id });
  }

  private async reportDelete(class_id: number) {
    // reportSend(this, class_id, 'report');
    const isOK = await MessageDialog.confirm('この日の日報を削除します。よろしいですか？');
    if (isOK) {
      const biz = new DaLessonsService();
      await biz.deleteLesson(class_id);
    }
  }

  /**
   * ダイアログを開く
   */
  public async show(student_user_id: string, nickname: string, building: string) {
    this.title = `${nickname}さんの受講レッスン一覧`;
    const biz = new LessonsService();
    const result = await biz.getLessonsForStudentWithoutTerm(student_user_id);
    this.lessons = result.data;
    await (this.$refs['da_student_dialog'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['da_student_dialog'] as CommonDialog).hide();
  }
}
